import React from 'react';
import { Box } from 'src/kit/Box';
import { Flex } from 'src/kit/Flex';
import LandingSignUpForm from 'src/components/LandingSignUpForm';
import styled from 'styled-components';
import atsBg from 'images/new_landing/ats-bg.svg';

type Props = {
  t: any;
};

const SectionWrapper = styled(Box)`
  padding: 160px 5%;
  background: #F4F6F9;
  position: relative;
  overflow: hidden;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 50%;
  left: -2%;
  transform: translateY(-50%);
  width: 900px;
  max-width: 100vw;
  opacity: 0.35;
  pointer-events: none;
  z-index: 0;
  filter: hue-rotate(110deg) saturate(1.5) brightness(1.1);
`;

const ContentFlex = styled(Flex)`
  max-width: 1200px;
  margin: 0 auto;
  gap: 80px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
`;

const EmployerSignupSection = ({ t }: Props) => {
  return (
    <SectionWrapper id="sign-up">
      <BackgroundImage src={atsBg} alt="" />
      <ContentFlex>
        <Box style={{ flex: '1 1 420px', color: '#0D1B2A' }}>
          <Box
            as="h2"
            style={{
              fontSize: '2.5rem',
              lineHeight: 1.2,
              marginBottom: '24px',
              fontWeight: 700,
              letterSpacing: '-0.02em'
            }}
          >
            Start hiring exceptional talent today
          </Box>
          <Box style={{ color: '#5B6B7A', fontSize: '1.05rem', marginBottom: '16px' }}>
            Join leading employers using Sainoo to connect with high-performing students and graduates.
          </Box>
          <Box style={{ color: '#0277bd', fontWeight: 600 }}>Fast setup. No commitment. Direct university access.</Box>
        </Box>

        <Box
          style={{
            flex: '1 1 420px',
            background: '#ffffff',
            borderRadius: '10px',
            padding: '48px',
            border: '1px solid #E6ECF2',
            boxShadow: '0 20px 50px rgba(13, 27, 42, 0.08)'
          }}
        >
          <LandingSignUpForm t={t} />
        </Box>
      </ContentFlex>
    </SectionWrapper>
  );
};

export default EmployerSignupSection;
